import script from "./PaymentPrintInvoiceAkt.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPrintInvoiceAkt.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPrintInvoiceAkt.vue?vue&type=style&index=0&id=00c8c9d1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c8c9d1"]])

export default __exports__